import { createContext, useContext, useEffect, useState } from "react"
import { useGlobal } from "../../../context/GlobalContext";
import * as apiMarketCategory from "../api/apiMarketCategory";
import { useSettings } from "../../../context/SettingsContext";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useToast } from "../../../context/ToastContext";
import { getBrands } from "../api/apiMarketDir";

const MarketContext = createContext();
export const useMarket = () => useContext(MarketContext);

export const MarketProvider = ({children}) =>{
 
    const { g } = useGlobal(); 
    const { t } = useTranslation();
    const { showToast } = useToast();
    const { settings } = useSettings();
    const [ categoriesList, setCategoriesList ] = useState(null);
    const [ categoryBreadcrumbs, setCategoryBreadcrumbs ] = useState(null);
    const [ showSub, setShowSub ] = useState(true);
    const [ categoryMove, setCategoryMove ] = useState(null);
    const [ currentCategoryId, setCurrentCategoryId ] = useState(0); 
    const [ langs, setLangs ] = useState(null);
    const [ productsOrder, setProductsOrder ] = useState(null);
    const [ productsDesc, setProductsDesc ] = useState(false);
    const [ brands, setBrands ] = useState(null);
    const [ attrCopy, setAttrCopy ] = useState(null);
    const [ productCopy, setProductCopy ] = useState(null);

    const location = useLocation();

    const fetchBrands = async () =>{
        const resBrands = await getBrands();
        setBrands(resBrands);
    } 

    // Оновюємо список категорій
    const fetchCategories = async (lang = g.localeFilter) => {
        const resCategories = await apiMarketCategory.getCategoryList(lang);
        if (!resCategories) showToast(t('common:messError'), 'danger');
        setCategoriesList(resCategories); 
        return resCategories!==null;
    };
 
    // Отримуємо "хлібні крихти" для поточної категорії
    const fetchBreadcrumbs = async (categoryId) => {
        const resBreadcrumb = await apiMarketCategory.getBreadcrumbs(categoryId, g.localeFilter);
        setCategoryBreadcrumbs(resBreadcrumb) 
    }

    // Оновлюэмо категорії по фільтрку
    useEffect(()=>{
        fetchCategories(g.localeFilter);
    }, [g.localeFilter,  g.search?.[location.pathname], g.target ])
 
    // Оновлюэмо масив мов
    useEffect(()=>{ 
        if (settings?.site?.locales) {
            const aLocales = settings?.site?.locales?.split(','); 
            setLangs(settings?.DIRS?.langs
                        .filter(l=>aLocales.includes(l.lang_prefix) !== false)
                        .map(l=>({...l, default:(l.lang_prefix==aLocales?.[0])}))
                );
        } 
        else setLangs([{ID:1, lang_prefix:'', lang_name:t('default')}]);
    }, [settings?.site?.locales]);

    useEffect(()=>{
        fetchBrands();
    },[])

    const values = {
        fetchCategories,
        fetchBreadcrumbs,
        categoriesList,
        categoryBreadcrumbs,
        currentCategoryId, 
        setCurrentCategoryId,
        showSub, 
        setShowSub,
        categoryMove,
        setCategoryMove,

        productsDesc, setProductsDesc,
        productsOrder, setProductsOrder,
        productCopy, setProductCopy,
        attrCopy, setAttrCopy, 
        brands,
        
        langs
    }

    return (
        <MarketContext.Provider
            value={values}>
            {children}
        </MarketContext.Provider> 
    );

}